const GET_MAIN_COLLECTION = `
{
	collectionByHandle(handle: "all") {
  	products(first: 250) {
      edges {
        node {
          handle
          title
          id
          availableForSale
        }
      }
    }
  }
}
`

const graphqlEndpoint = 'https://nsupa.myshopify.com/api/graphql.json';

const headers = {
  'Content-Type': 'application/json', 
  'X-Shopify-Storefront-Access-Token': '87c206078a86f859e88a67220a74e1af',
}

export const getMainCollection = () => {
  return fetch('https://nsupa.myshopify.com/api/graphql.json', {
    method: 'POST',
    headers,
    body: JSON.stringify({ query: GET_MAIN_COLLECTION }) 
  })
  .then(res => res.json())
  .then(response => response.data.collectionByHandle.products.edges)
}

export const getProductVariantsByHandle = (handle) => {
  const query = `
  {	
    productByHandle(handle: "${handle}") {
      variants(first: 100) {
        edges {
          node {
            id
            availableForSale
            price
            selectedOptions {
              name
              value
            }
            title
          }
        }
      }
    }
  }
  `

  return fetch(graphqlEndpoint, {
    method: 'POST',
    headers,
    body: JSON.stringify({ query }) 
  })
  .then(res => res.json())
  .then(data => data.data.productByHandle.variants.edges)
}
